import React, { useEffect, useState } from 'react';
import CardUI from '../../../widgets/layout/CardUI';
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI';
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI';
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI';
import BadgeUI from '../../../widgets/output/BadgeUI';

const MessageApprovalWhatsAppListUI = ({ context, messages, onUpdateMessageClick }) => {
  const [phoneNumbersMap, setPhoneNumbersMap] = useState({});

  useEffect(() => {
    try {
      const phoneNumbersStr = localStorage.getItem('phoneNumbers');
      if (phoneNumbersStr) {
        const numbersMap = JSON.parse(phoneNumbersStr);
        setPhoneNumbersMap(numbersMap);
      }
    } catch (error) {
      console.error('Error loading phone numbers from localStorage:', error);
      setPhoneNumbersMap({});
    }
  }, [messages]);

  return (
    <div>
      {messages.map((message, i) => {
        const messagePhones = phoneNumbersMap[message.messageApprovalId] || [];

        return (
          <LRTableBodyUI key={i}>
            <CardUI>
              <div className='g_flex_h g_flex_top g_flex_left'>
                {/* Internal Phone Recipients */}
                <LabelAndValueUI label='Internal Phone Recipients'>
                  {messagePhones.length > 0 ? (
                    <div className='g_flex_v'>
                      {messagePhones.map((phone, j) => (
                        <span key={`phone-${j}`} className='g_flex_v'>
                          {phone}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <span>-</span>
                  )}
                </LabelAndValueUI>

                <span className='g_m_right_100' />
                <span className='g_m_right_100' />

                {/* <LabelAndValueUI label='File Attachments'>
                  {message.fileUploadList && message.fileUploadList.length > 0 ? (
                    message.fileUploadList.map((file, j) => (
                      <span key={`file-${j}`} className='g_flex_v'>
                        {file}
                      </span>
                    ))
                  ) : (
                    <span>-</span>
                  )}
                </LabelAndValueUI> */}

                {/* Metadata section */}
                <span className='g_flex_v g_m_left_auto g_text_right'>
                  <LabelAndValueUI label='Updated By'>
                    <span>{message.updatedByUserName || '-'}</span>
                  </LabelAndValueUI>

                  <LabelAndValueUI label='Sent By'>
                    <span>{message.sentByUserName || '-'}</span>
                  </LabelAndValueUI>

                  <LabelAndValueUI label="Sent Date">
                    <span>
                      {message.sentDate ? message.sentDate : '-'}
                    </span>
                  </LabelAndValueUI>

                </span>
              </div>
            </CardUI>

            <LRTableRowUI
              className='g_flex_top'
              left={<RowLeftUI message={message} />}
              right={<RowRightUI message={message} onUpdateMessageClick={onUpdateMessageClick} />}
            />
          </LRTableBodyUI>
        );
      })}
    </div>
  );
};

// RowLeftUI component to display message details
const RowLeftUI = ({ message }) => (
  <div>
    Subject: {message.emailSubject}<br />
    <span dangerouslySetInnerHTML={{ __html: message.message }} />
  </div>
);


const RowRightUI = ({ message, onUpdateMessageClick }) => (
  <div className='g_flex_h'>
    {/* Edit (pencil) icon */}
    {
      message.pendingStatus &&
      <BadgeUI label={message.pendingStatus} />
    }
    {/* <span
      className='icon icon-pencil g_m_left_50'
      onClick={onUpdateMessageClick}
      message-approval-id={message.messageApprovalId}
    /> */}
  </div>
);
export default MessageApprovalWhatsAppListUI;
